<template>
  <div class="totalTrees" v-if="$store.state.reservaAct !== null && $store.state.bigMap !== true">
    <div class="flex items-top w-full ">
      <div class="flex-1 flex flex-col labels truncate items-center">
        <div class="flex mt-1">
          <label class="specieName truncate">
            {{ $t('apadrinados') }} 
          </label>
          <label class="truncate ml-1">
             {{numberSeeds}} / {{numberTrees}}
          </label>
        </div>
        <div class="bar mt-1" style="background: rgba(219,170,0,0.2); border-radius: 10px">
          <div class="bar-item tooltip" role="progressbar" v-bind:style="{width: numberSeeds / (numberTrees) * 100 + '%'}" style="border-radius: 10px;"></div>
        </div>
        <iframe class="mt-3" width="240" height="135" :src="$store.state.reserves.items[this.$store.state.reservaAct].url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <div v-if="profile" class="flex-1 mt-3 mb-1"  @click="buySeeds">
          <label id="apadrinamapa" class="plantText label label-rounded label-primary truncate mb-1">{{ $t('apadrinalo') }}</label>
        </div>
        <div v-else class="flex-1 mt-3 mb-1"  @click="buySeeds">
          <label id="registroderecho" class="plantText label label-rounded label-primary truncate mb-1">{{ $t('registrate') }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapGetters} from 'vuex'
import BuySeeds from '@/components/modals/BuySeeds'
export default {
  name: 'TotalTrees',
  components: { 
    
  },
  computed: {
    ...mapState('auth', ['ready', 'user', 'profile']),
  },
  props: ['numberSeeds', 'numberTrees'],
  data () {
    return {
      plantedIcon: require('@/assets/images/tree_icon_planted.svg')
    }
  },
  methods: {
    buySeeds() {
      if(this.$store.state.auth.user==null){
          this.$store.dispatch('auth/showSession', true)
      }else{
      this.$bvueUi.modal.show({
        component: BuySeeds,
        width: 600,
        height: 500,
        data: {
          //reserveId: this.modalData.reserveId
          reserveId: this.reservaAct
        }
      })
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.container {
 justify-content: center;
}

//Edit Button
.plantText {
  cursor: pointer;
  font-weight: 500;
}

//Position of Trees 265
.totalTrees:hover{
   opacity: 1;
 }
.totalTrees {
 position:absolute;
 border-radius: 5px;
 opacity: 0.9;
  background:white;
  top:25px;
  width:auto;
  right:25px;
  left:auto;
  padding: 15px;
  @media screen and (min-width: $break-large) {
    width: auto;
    top: 25px;
    right: 25px;
    left: auto;
    margin-left: -230px;
  }
  @media screen and (max-width: $break-small) {
    width:auto;
    right:5%;
    left:5%;
    padding: 10px;
    .plantText {
      max-width: 154px;
    }
  }
  .flex items-top w-full {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TotalTrees.vue